<div class="porHeader wrapper por-ac-header">
    <a href="javascript:void(0)" class="logo">
        <img class="header-logo" src="{{ adminConfig.uiUrl }}/assets/images/POR_eCommerce_logo.svg" />
    </a>
    @if (showTabs) {
    <por-admin-page-sidebar></por-admin-page-sidebar>
    }
</div>
